import React from 'react'

const Search = ({
                    onChange,
                    value,
                }) => (
  <div className="consultants__search search-field">
      <input
        onChange={onChange}
        type="text"
        className={`consultants__search-input search-input ${value ? 'focused' : ''}`}
        value={value}
      />
      <span className="consultants__search-label search-title">Sök</span>
      <img src={`${window.MS_Ajax.rootDir}/images/search.svg`} className="consultants__search-icon" alt="search icon"/>
  </div>
)

export default Search
